(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorelay-mystery-offer"]) return;
  try {
    
  if (!customElements.get('sorelay-mystery-offer')) {
    customElements.define('sorelay-mystery-offer', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const opts = {signal:this.abort.signal};
        this.dialog = this.querySelector('dialog');
        this.canvas = this.querySelector('canvas');
        this.reward = this.querySelector('.sorelay-offer-reward');
        this.launcher = this.querySelector('.sorelay-offer-launch');
        this.storageKey = 'sorelay-offer-seen-' + this.dataset.key;
        this.launcher.addEventListener('click',()=>this.open(),opts);
        this.querySelector('.sorelay-offer-close').addEventListener('click',()=>this.dialog.close(),opts);
        this.querySelector('.sorelay-offer-decline').addEventListener('click',()=>this.dialog.close(),opts);
        this.querySelector('.sorelay-offer-reveal').addEventListener('click',()=>this.reveal(),opts);
        this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow;this.launcher.focus();},opts);
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},opts);
        this.canvas.addEventListener('pointerdown',event=>{this.drawing=true;this.canvas.setPointerCapture(event.pointerId);this.erase(event);},opts);
        this.canvas.addEventListener('pointermove',event=>{if(this.drawing)this.erase(event);},opts);
        this.canvas.addEventListener('pointerup',()=>{this.drawing=false;this.lastPoint=null;this.checkCoverage();},opts);
        this.canvas.addEventListener('pointercancel',()=>{this.drawing=false;this.lastPoint=null;},opts);
        this.resizeObserver=new ResizeObserver(()=>{if(this.dialog.open&&!this.revealed)this.paint();});
        this.resizeObserver.observe(this.querySelector('.sorelay-scratch'));
        let seen=0;
        try {seen=Number(localStorage.getItem(this.storageKey)||0);} catch {}
        if(this.dataset.preview!=='true'&&Date.now()-seen>7*86400000) {
          this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open]')&&document.visibilityState==='visible')this.open();},Number(this.dataset.delay)*1000);
        }
      }
      open() {
        if(this.dialog.open)return;
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow='hidden';
        try {localStorage.setItem(this.storageKey,String(Date.now()));} catch {}
        if(!this.revealed)requestAnimationFrame(()=>this.paint());
      }
      paint() {
        const r=this.canvas.getBoundingClientRect();
        if(!r.width||!r.height)return;
        this.canvas.width=Math.round(r.width);this.canvas.height=Math.round(r.height);
        this.ctx=this.canvas.getContext('2d',{willReadFrequently:true});
        if(!this.ctx){this.reveal();return;}
        this.ctx.fillStyle='#a1d9c6';this.ctx.fillRect(0,0,r.width,r.height);
        this.ctx.strokeStyle='#83bda9';this.ctx.lineWidth=1;
        for(let x=-r.height;x<r.width;x+=18){this.ctx.beginPath();this.ctx.moveTo(x,0);this.ctx.lineTo(x+r.height,r.height);this.ctx.stroke();}
        this.ctx.fillStyle='#203a30';this.ctx.font='600 22px sans-serif';this.ctx.textAlign='center';this.ctx.textBaseline='middle';this.ctx.fillText(this.dataset.scratch,r.width/2,r.height/2);
        this.ctx.globalCompositeOperation='destination-out';this.ctx.lineWidth=44;this.ctx.lineCap='round';
      }
      erase(event) {
        if(this.revealed||!this.ctx)return;
        this.reward.hidden=false;
        const r=this.canvas.getBoundingClientRect();const point={x:event.clientX-r.left,y:event.clientY-r.top};
        this.ctx.beginPath();this.ctx.moveTo(this.lastPoint?.x??point.x,this.lastPoint?.y??point.y);this.ctx.lineTo(point.x,point.y);this.ctx.stroke();
        this.ctx.beginPath();this.ctx.arc(point.x,point.y,22,0,Math.PI*2);this.ctx.fill();this.lastPoint=point;
      }
      checkCoverage() {
        if(this.revealed||!this.ctx)return;
        const data=this.ctx.getImageData(0,0,this.canvas.width,this.canvas.height).data;
        let erased=0,total=0;
        for(let i=3;i<data.length;i+=64){total++;if(data[i]<128)erased++;}
        if(erased/total>.3)this.reveal();
      }
      reveal() {
        this.revealed=true;this.canvas.hidden=true;this.reward.hidden=false;
        this.querySelector('.sorelay-offer-reveal').hidden=true;
        this.querySelector('.sorelay-offer-result').hidden=false;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);this.abort?.abort();this.resizeObserver?.disconnect();
        if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorelay-opening-carousel"] && !Shopify.designMode) return;
  try {
    
function sorelayStartCarousels(){document.querySelectorAll('.sorelay-opening-carousel').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('.soc-slide')],dots=[...root.querySelectorAll('.soc-dots button')];let index=0,timer;const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((s,i)=>{let active=i===index;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',String(!active));if(active)s.removeAttribute('inert');else s.setAttribute('inert','')});dots.forEach((b,i)=>{b.classList.toggle('is-active',i===index);if(i===index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')})};const stop=()=>clearInterval(timer),start=()=>{stop();if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&!document.hidden)timer=setInterval(()=>show(index+1),Number(root.dataset.interval)||5500)};root.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>{show(index+(b.dataset.direction==='next'?1:-1));start()}));dots.forEach(b=>b.addEventListener('click',()=>{show(Number(b.dataset.slide));start()}));root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))start()});document.addEventListener('visibilitychange',()=>document.hidden?stop():start());start()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sorelayStartCarousels);else sorelayStartCarousels();document.addEventListener('shopify:section:load',sorelayStartCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorelay-sale-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sorelay-sale-welcome')) {
    customElements.define('sorelay-sale-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.sorelay-sale-banner');
        const key = 'sorelay-summer-2026-seen';
        const open = () => {
          if (!this.isConnected || dialog.open || document.querySelector('dialog[open]')) return;
          dialog.showModal();
          try { sessionStorage.setItem(key, '1'); } catch {}
        };
        trigger.addEventListener('click', open);
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        let seen = false;
        try { seen = sessionStorage.getItem(key) === '1'; } catch {}
        if (this.querySelector('[data-signup-result]')) open();
        else if (!seen && !window.Shopify?.designMode) this.timer = setTimeout(open, 4000);
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
